module.exports = __webpack_public_path__ + "img/hugging-face.861afd30.png";